import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@material-ui/core";

export interface Diet {
  title: string;
  carb?: string;
  protein?: string;
  fats?: string;
  description: string;
}

interface DietPopupProps {
  open: boolean;
  onClose: () => void;
  onSelect: (diet: Diet) => void;
}

const diets: Diet[] = [
  {
    title: "Dieta Equilibrada 🌱🔄",
    carb: "50%",
    protein: "20%",
    fats: "30%",
    description:
      "La más recomendada para quienes buscan un enfoque saludable y sostenible.",
  },
  {
    title: "Dieta Hipocalórica (Déficit Calórico - Pérdida de Peso) 🔥📉",
    carb: "40%",
    protein: "35%",
    fats: "25%",
    description:
      "Es la más usada para bajar de peso y mejorar la composición corporal.",
  },
  {
    title: "Dieta Hipercalórica (Volumen o Aumento de Masa Muscular) 💪🏋️",
    carb: "50%",
    protein: "30%",
    fats: "20%",
    description:
      "Muy común entre quienes buscan ganar músculo y mejorar rendimiento.",
  },
  {
    title: "Dieta Cetogénica (Keto) 🥑🥓",
    carb: "5%",
    protein: "30%",
    fats: "65%",
    description:
      "Popular para pérdida de peso rápida y control de glucosa.",
  },
  {
    title: "Dieta Baja en Carbohidratos (Low Carb) 🍳🥩",
    carb: "20%",
    protein: "40%",
    fats: "40%",
    description:
      "Similar a la keto, pero menos estricta; utilizada para pérdida de peso y mejorar resistencia a la insulina.",
  },
  {
    title: "Dieta Alta en Proteínas 🥩🍗",
    carb: "30%",
    protein: "45%",
    fats: "25%",
    description:
      "Ideal para deportistas y personas que buscan conservar músculo en déficit calórico.",
  },
  {
    title: "Dieta Vegetariana 🥦🌽",
    carb: "50%",
    protein: "20%",
    fats: "30%",
    description:
      "Usada por quienes prefieren evitar la carne sin renunciar a proteínas vegetales.",
  },
  {
    title: "Dieta Vegana 🌿🥑",
    carb: "50%",
    protein: "20%",
    fats: "30%",
    description:
      "Cada vez más popular por razones éticas, ambientales y de salud.",
  },
  {
    title: "Dieta Mediterránea 🍅🫒",
    carb: "45%",
    protein: "25%",
    fats: "30%",
    description:
      "Reconocida por sus beneficios para el corazón y la longevidad.",
  },
];

const DietPopup: React.FC<DietPopupProps> = ({ open, onClose, onSelect }) => {
  const handleSelect = (diet: Diet) => {
    onSelect(diet);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Selecciona un tipo de dieta</DialogTitle>
      <DialogContent dividers>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
          {diets.map((diet, index) => (
            <Card
              key={index}
              style={{ width: "calc(50% - 16px)", cursor: "pointer" }}
              onClick={() => handleSelect(diet)}
            >
              <CardActionArea>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {diet.title}
                  </Typography>
                  {diet.carb && (
                    <Typography variant="body2">
                      <strong>Carbohidratos:</strong> {diet.carb}
                    </Typography>
                  )}
                  {diet.protein && (
                    <Typography variant="body2">
                      <strong>Proteínas:</strong> {diet.protein}
                    </Typography>
                  )}
                  {diet.fats && (
                    <Typography variant="body2">
                      <strong>Grasas:</strong> {diet.fats}
                    </Typography>
                  )}
                  <Typography variant="body2" color="textSecondary">
                    {diet.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DietPopup;
